import { Accordion } from '@chakra-ui/react'
import { Children, type ReactNode, useEffect, useMemo, useState } from 'react'

interface PrintAccordionProps {
  children: ReactNode
  expandAll: boolean
}

const PrintAccordion = ({ children, expandAll }: PrintAccordionProps) => {
  const allExpandedIndexes = useMemo(
    () => Array.from({ length: Children.count(children) }, (_, index) => index),
    [children],
  )
  const [expandedIndexes, setExpandedIndexes] = useState<number[]>(() =>
    expandAll ? allExpandedIndexes : [],
  )

  useEffect(() => {
    setExpandedIndexes(expandAll ? allExpandedIndexes : [])
  }, [allExpandedIndexes, expandAll])

  const handleChange = (nextExpandedIndexes: number | number[]) => {
    setExpandedIndexes(
      Array.isArray(nextExpandedIndexes)
        ? nextExpandedIndexes
        : [nextExpandedIndexes],
    )
  }

  return (
    <Accordion
      allowMultiple
      index={expandedIndexes}
      onChange={handleChange}
      sx={{
        '.chakra-accordion__button': {
          fontSize: 'lg',
        },
      }}
    >
      {children}
    </Accordion>
  )
}

export default PrintAccordion
